import React from 'react';
import AppPageHeader from '../shell/AppPageHeader';
import ChangePasswordSection from '../shared/ChangePasswordSection';
import { shellMainPaddingX } from '../../utils/shellLayoutClasses';

export default function AdminSettings() {
  return (
    <main className="flex-1 flex flex-col min-h-0 min-w-0">
      <AppPageHeader title="Settings" subtitle="Account security" />
      <div className={`flex-1 overflow-auto pb-8 pt-3 sm:pt-4 ${shellMainPaddingX}`}>
        <div className="w-full space-y-6">
          <ChangePasswordSection />
        </div>
      </div>
    </main>
  );
}
